module.exports = __webpack_public_path__ + "img/background-main-decree.acd6a792.svg";